<template>
    <label class="font-medium" :class="label_class">{{ label }}</label>
    <div class="flex items-center border border-gray-300 rounded-md p-2 focus-within:ring-2 focus-within:ring-blue-500">
        <component v-if="iconLeft" :is="iconLeft" class="h-5 w-5 text-gray-400" />
        <input :id="id" :type="type" :name="name" :placeholder="placeholder" :value="modelValue"
            :disabled="disable_input" @input="$emit('update:modelValue', $event.target.value)"
            class="flex-1 border-none outline-none focus:ring-0" :class="[!valid ? 'p-invalid' : '']" />
        <component v-if="iconRight" :is="iconRight" class="h-5 w-5 text-gray-400" />
    </div>
    <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
    </Message>
</template>

<script>
import { Message } from 'primevue';

export default {
    name: 'InputTextWithIcon',
    components: {
        Message
    },
    props: {
        label: String,
        label_class: String,
        id: String,
        type: String,
        name: String,
        placeholder: String,
        modelValue: String,
        disable_input: Boolean,
        valid: Boolean,
        errorMessage: String,
        iconLeft: {
            type: [Object, String],
            default: null
        },
        iconRight: {
            type: [Object, String],
            default: null
        }
    },
    emits: ['update:modelValue'],
}
</script>